import React from 'react';
import {createRoot} from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {Tooltip} from 'react-tooltip';

import Home from '@common/pages/Home';
import JwtScopeConstants from '@common/constants/authentication/JwtScopeConstants';
import AuthGuard from '@common/components/AuthGuard';
import ScopedJwtGuard from '@common/components/ScopedJwtGuard';
import ConfigLoader from '@common/components/ConfigLoader';
import piuRoutes from '@modules/piu/routes';
import referentialRoutes from '@modules/referential/routes';

import './index.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <AuthGuard />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        element: <ScopedJwtGuard jwtScope={{scope: JwtScopeConstants.WEBAPP, withStatic: true}} />,
        children: piuRoutes
      },
      {
        element: <ScopedJwtGuard jwtScope={{scope: JwtScopeConstants.WEBAPP, withStatic: true}} />,
        children: referentialRoutes
      }
    ]
  }
]);

const rootNode = document.getElementById('root');

if (rootNode) {
  createRoot(rootNode).render(
    <React.StrictMode>
      <ConfigLoader>
        <RouterProvider router={router} />
      </ConfigLoader>

      <Tooltip
        id="list-tooltip"
        render={({content}) => {
          if (!content) {
            return null;
          }
          const contentArray = content.split('|');
          return (
            <ul className="max-w-xl">
              {contentArray.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          );
        }}
      />

      <Tooltip
        id="main-tooltip"
        render={({content}) => (
          <div className="max-w-md">
            <p className="text-wrap">{content}</p>
          </div>
        )}
      />

      <Tooltip id="html-tooltip" />
    </React.StrictMode>
  );
} else {
  throw new Error('Root node not found');
}
